import React from 'react'
import PropTypes from 'prop-types'

import { SecondaryButton } from '@aok/ui-elements'
import { ArrowRoundedRight } from '@aok/icon-functional'

import ModuleContainer from '../../_layout/Module/ModuleContainer'

const TeaserListPageLink = ({ url, title }) => {
  return (
    <ModuleContainer className="flex justify-center">
      <SecondaryButton url={url}>
        {title}
        <ArrowRoundedRight className="ml-8 fill-current w-16 h-16" />
      </SecondaryButton>
    </ModuleContainer>
  )
}

TeaserListPageLink.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
}

export default TeaserListPageLink
